/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DanceListItem } from './DanceListItem';
import {
    DanceListItemFromJSON,
    DanceListItemFromJSONTyped,
    DanceListItemToJSON,
    DanceListItemToJSONTyped,
} from './DanceListItem';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfDanceListItem
 */
export interface ResultOfIReadOnlyListOfDanceListItem {
    /**
     * 
     * @type {Array<DanceListItem>}
     * @memberof ResultOfIReadOnlyListOfDanceListItem
     */
    data: Array<DanceListItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfDanceListItem
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfDanceListItem
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfDanceListItem interface.
 */
export function instanceOfResultOfIReadOnlyListOfDanceListItem(value: object): value is ResultOfIReadOnlyListOfDanceListItem {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfDanceListItemFromJSON(json: any): ResultOfIReadOnlyListOfDanceListItem {
    return ResultOfIReadOnlyListOfDanceListItemFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfDanceListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(DanceListItemFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfDanceListItemToJSON(json: any): ResultOfIReadOnlyListOfDanceListItem {
    return ResultOfIReadOnlyListOfDanceListItemToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceListItemToJSONTyped(value?: ResultOfIReadOnlyListOfDanceListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(DanceListItemToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

